import React from 'react';
import ReactSelect, { OptionTypeBase, Props, ValueType } from 'react-select';

import { useField } from 'formik';

import customStyles from './customStyles';
import { Container, LabelContainer, ErrorMessage } from './styles';

export interface SelectProps extends Props<OptionTypeBase> {
  name: string;
  label?: string;
  optional?: boolean;
}

const Select: React.FC<SelectProps> = ({
  name,
  label = null,
  options,
  defaultValue,
  optional = false,
  ...rest
}) => {
  const [field, meta, helpers] = useField<string | string[] | null>(name);
  const { value: selectedOptions } = field;
  const { error } = meta;
  const { setValue } = helpers;

  const setNewValue = (newOption: ValueType<OptionTypeBase>) => {
    if (rest.isMulti) {
      if (!newOption || !(newOption instanceof Array)) {
        setValue([]);
        return;
      }
      const newValue = newOption.map((option: OptionTypeBase) => option.value);
      setValue(newValue);
      return;
    }
    if (
      newOption instanceof Array &&
      newOption.length > 0 &&
      newOption[0].value
    ) {
      setValue(newOption[0].value);
      return;
    }
    setValue((newOption as OptionTypeBase)?.value);
  };

  const hasValue = (value: string): boolean => {
    if (selectedOptions instanceof Array) {
      return selectedOptions.some((option) => option === value);
    }
    return value === selectedOptions;
  };

  return (
    <Container hasLabel={!!label}>
      {label && (
        <LabelContainer>
          {<label htmlFor={name}>{label}</label>}{' '}
          {optional && <small>(Opcional)</small>}
        </LabelContainer>
      )}
      <ReactSelect
        noOptionsMessage={() => 'Não há opções'}
        defaultValue={
          options?.find((option) => option.value === defaultValue) ||
          defaultValue
        }
        value={options?.filter((option) => hasValue(option.value))}
        onChange={(value) => setNewValue(value)}
        classNamePrefix="react-select"
        options={options}
        menuPlacement="auto"
        menuPortalTarget={document.body}
        styles={customStyles}
        {...rest}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Container>
  );
};
export default Select;
